<template>
  <v-container>
    <!-- User has a valid account -->
    <v-row v-if="isValidAccount">
      <v-col xs="12" md="12">
        <v-alert border="top" prominent colored-border type="warning" v-if="showUpdateInfo">
          <v-row align="center">
            <v-col class="grow">Please update your profile with all required fields.</v-col>
          </v-row>
        </v-alert>
        <!-- <v-alert border="top" colored-border type="info" v-if="showConnectBox">
          <v-row align="center">
            <v-col
              class="grow"
            >Instagram signed in users have a very high chance in receiving Campaign Invitations.</v-col>
            <v-col class="shrink">
              <v-btn color="instagram" @click="connectInstagram" large>
                Connect
                <v-icon right dark>fa fa-instagram</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-alert> -->
        <v-card flat>
          <v-form v-model="valid">
            <v-expansion-panels v-model="openedPanels" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header class="title">Contact Information *</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col xs="12" sm="12" md="2" class="pp-section text-center">
                      <v-avatar size="120">
                        <img
                          style="margin: 0 auto"
                          v-bind:src="activeUser.avatar"
                          alt="User Profile Image"
                          @click="changeProfilePicture"
                        >
                      </v-avatar>
                      <div>
                        <v-btn small color="warning" class="text-center mt-2" @click="changeProfilePicture"><v-icon size="15">mdi-pencil</v-icon> Edit</v-btn>
                      </div>
                    </v-col>
                    <v-col xs="12" md="10">
                      <v-col xs="12" md="4">
                        <!-- <div class="d-flex flex-row" v-if="showConnectBox || !userData.igHandle" style="margin-top: -48px;justify-content: center;">
                          <v-btn class="mt-3" color="instagram" @click="connectInstagram" text>
                            Connect to Instagram
                            <v-icon right dark>fa fa-instagram</v-icon>
                          </v-btn>
                        </div> -->
                        <div class="d-flex flex-row">
                          <v-text-field
                            label="Instagram Account"
                            v-model="userData.reqIgHandle"
                            v-if="userData.reqIgHandle"
                            disabled
                          />
                          <v-text-field
                            label="Instagram Account"
                            v-model="userData.igHandle"
                            :disabled="userData.igHandle !== ''"
                            v-else
                          />
                          <v-icon style="height:100%;margin-top:25px;margin-right:5px;" v-on="on" small v-if="userData.reqIgHandle">mdi-account-clock</v-icon>
                          <!-- <v-icon style="cursor:pointer;height:100%;margin-top:25px;" v-on="on" small
                            v-if="!userData.igHandle" @click="openUpdatePlatformDialog()">edit</v-icon> -->
                          <v-btn
                            style="margin-top:20px;min-width:10px;"
                            x-small
                            color="warning"
                            @click="openUpdatePlatformDialog()"
                            v-if="!userData.igHandle"
                          >
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }"> 
                                <v-icon style="cursor:pointer;" v-on="on" x-small>edit</v-icon>
                              </template>
                              <span>Update Instagram</span>
                            </v-tooltip>
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col class="d-flex flex-row" xs="12" md="4">
                        <v-text-field
                          label="Facebook Account"
                          v-model="userData.fbHandle"
                          disabled
                        />
                        <v-btn
                          v-if="userData.fbHandle"
                          :href="'https://www.facebook.com/' + userData.fbHandle"
                          target="_blank"
                          rel="noopener noreferrer"
                          style="margin-top:20px;min-width:10px;"
                          x-small
                          color="warning"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon style="cursor:pointer;" v-on="on" x-small>mdi-facebook</v-icon>
                            </template>
                            <span>View Facebook Profile</span>
                          </v-tooltip>
                        </v-btn>
                        <v-btn
                          v-else
                          style="margin-top:20px;min-width:10px;"
                          x-small
                          color="warning"
                          @click="openUpdatePlatformDialog()"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon style="cursor:pointer;" v-on="on" x-small>edit</v-icon>
                            </template>
                            <span>Update Facebook</span>
                          </v-tooltip>
                        </v-btn>
                      </v-col>
                      <v-col class="d-flex flex-row" xs="12" md="4">
                        <v-text-field
                          label="TikTok Account"
                          v-model="userData.reqTikTokHandle"
                          v-if="userData.reqTikTokHandle"
                          disabled
                        />
                        <v-text-field
                          label="TikTok Account"
                          v-model="userData.tiktokHandle"
                          :disabled="userData.tiktokHandle !== ''"
                          v-else
                        />
                        <v-icon style="height:100%;margin-top:25px;margin-right:5px;" v-on="on" small v-if="userData.reqTikTokHandle">mdi-account-clock</v-icon>
                        <!-- <v-icon style="cursor:pointer;height:100%;margin-top:25px;" v-on="on" small
                        v-if="!userData.tiktokHandle" @click="openUpdatePlatformDialog()">edit</v-icon> -->
                        <v-btn
                          style="margin-top:20px;min-width:10px;"
                          x-small
                          color="warning"
                          @click="openUpdatePlatformDialog()"
                          v-if="!userData.tiktokHandle"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }"> 
                              <v-icon style="cursor:pointer;" v-on="on" x-small>edit</v-icon>
                            </template>
                            <span>Update TikTok</span>
                          </v-tooltip>
                        </v-btn>
                      </v-col>
                      <v-col class="d-flex flex-row" xs="12" md="4">
                        <v-text-field
                          label="Youtube Account"
                          v-model="userData.reqYoutubeHandle"
                          v-if="userData.reqYoutubeHandle"
                          disabled
                        />
                        <v-text-field
                          label="Youtube Account"
                          v-model="userData.youtubeHandle"
                          :disabled="userData.youtubeHandle !== ''"
                          v-else
                        />
                        <v-icon style="height:100%;margin-top:25px;margin-right:5px;" v-on="on" small v-if="userData.reqYoutubeHandle">mdi-account-clock</v-icon>
                        <!-- <v-icon style="cursor:pointer;height:100%;margin-top:25px;" v-on="on" small
                        v-if="!userData.youtubeHandle" @click="openUpdatePlatformDialog()">edit</v-icon> -->
                        <v-btn
                          style="margin-top:20px;min-width:10px;"
                          x-small
                          color="warning"
                          @click="openUpdatePlatformDialog()"
                          v-if="!userData.youtubeHandle"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }"> 
                              <v-icon style="cursor:pointer;" v-on="on" x-small>edit</v-icon>
                            </template>
                            <span>Update Youtube</span>
                          </v-tooltip>
                        </v-btn>
                      </v-col>
                      <v-col class="d-flex flex-row" xs="12" md="4">
                        <v-text-field
                          label="X (Twitter) Account"
                          v-model="userData.twitterHandle"
                          disabled
                        />
                        <v-btn
                          v-if="userData.twitterHandle"
                          :href="'https://x.com/' + userData.twitterHandle"
                          target="_blank"
                          rel="noopener noreferrer"
                          style="margin-top:20px;min-width:10px;"
                          x-small
                          color="warning"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <img v-on="on" src="/static/img/x-logo.svg" width="12" height="12" class="x-logo-white" alt="X (Twitter)">
                            </template>
                            <span>View X (Twitter) Profile</span>
                          </v-tooltip>
                        </v-btn>
                        <v-btn
                          v-else
                          style="margin-top:20px;min-width:10px;"
                          x-small
                          color="warning"
                          @click="openUpdatePlatformDialog()"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon style="cursor:pointer;" v-on="on" x-small>edit</v-icon>
                            </template>
                            <span>Update X (Twitter)</span>
                          </v-tooltip>
                        </v-btn>
                      </v-col>
                      <v-col class="d-flex flex-row" xs="12" md="4">
                        <v-text-field
                          label="LinkedIn Account"
                          v-model="userData.reqLinkedinHandle"
                          v-if="userData.reqLinkedinHandle"
                          disabled
                        />
                        <v-text-field
                          label="LinkedIn Account"
                          v-model="userData.linkedinHandle"
                          disabled
                          v-else
                        />
                        <v-icon style="height:100%;margin-top:25px;margin-right:5px;" small v-if="userData.reqLinkedinHandle">mdi-account-clock</v-icon>
                        <v-btn
                          v-if="userData.linkedinHandle"
                          :href="'https://www.linkedin.com/in/' + userData.linkedinHandle"
                          target="_blank"
                          rel="noopener noreferrer"
                          style="margin-top:20px;min-width:10px;"
                          x-small
                          color="warning"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon style="cursor:pointer;" v-on="on" x-small>mdi-linkedin</v-icon>
                            </template>
                            <span>View LinkedIn Profile</span>
                          </v-tooltip>
                        </v-btn>
                        <v-btn
                          v-if="!userData.linkedinHandle && !userData.reqLinkedinHandle"
                          style="margin-top:20px;min-width:10px;"
                          x-small
                          color="warning"
                          @click="openUpdatePlatformDialog()"
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-icon style="cursor:pointer;" v-on="on" x-small>edit</v-icon>
                            </template>
                            <span>Update LinkedIn</span>
                          </v-tooltip>
                        </v-btn>
                      </v-col>
                      <v-col xs="12" md="4">
                        <v-text-field
                          class="purple-input"
                          label="First Name"
                          v-model="userData.firstName"
                          :error-messages="firstNameErrors"
                          required
                          @input="$v.userData.firstName.$touch()"
                          @blur="$v.userData.firstName.$touch()"
                        />
                      </v-col>
                      <v-col xs="12" md="4">
                        <v-text-field
                          class="purple-input"
                          label="Last Name"
                          v-model="userData.lastName"
                        />
                      </v-col>
                      <v-col xs="12" md="4">
                        <v-text-field
                          label="Email Address"
                          class="purple-input"
                          v-model="userData.email"
                          @keydown.space.prevent 
                          @input="removeSpaces" 
                          @paste="preventPasteSpaces" 
                          :error-messages="emailErrors"
                          required
                          @blur="$v.userData.email.$touch()"
                        />
                      </v-col>
                      <v-col xs="12" md="4">
                        <v-text-field
                          label="Contact Number"
                          class="purple-input"
                          v-model="userData.phone"
                        />
                      </v-col>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="title">Billing Information</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <table>
                    <tr>
                      <td>Full Name <small>(as per bank account)</small></td>
                      <td>
                        <div>
                          <v-text-field
                            class="edit-field"
                            v-model="userData.fullName"
                            dense
                            outlined
                            v-on="on"
                            hide-details
                          ></v-text-field>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Country</td>
                      <td>
                        <div>
                          <v-select
                            v-model="userData.country"
                            label="Country"
                            :items="countries"
                            item-text="name"
                            item-value="name"
                            @change="changeCountry"
                            attach
                            dense
                            hide-details
                            outlined
                          >
                          </v-select>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Bank Name</td>
                      <td>
                        <div>
                          <v-combobox
                            class="edit-field"
                            v-model="userData.bankName"
                            :items="bankNames"
                            item-text="bank"
                            item-value="bank"
                            :search-input.sync="newBankName"
                            attach
                            dense
                            hide-details
                            outlined
                          >
                            <template v-slot:no-data>
                              <v-list-item>
                                <span class="subheading pr-2" v-if="newBankName">{{ newBankName }}</span>
                              </v-list-item>
                            </template>
                          </v-combobox>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Bank Account Number</td>
                      <td>
                        <div>
                          <v-text-field
                            class="edit-field"
                            v-model="userData.bankAccount"                     
                            v-mask="'#################'"
                            dense
                            outlined
                            v-on="on"
                            hide-details
                          ></v-text-field>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Billing Email</td>
                      <td>
                        <div>
                          <v-text-field
                            class="edit-field"
                            v-model="userData.billingEmail"
                            dense
                            outlined
                            v-on="on"
                            hide-details
                          ></v-text-field>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>Mailing Address</td>
                      <td>
                        <div>
                          <v-text-field
                            class="edit-field"
                            v-model="userData.mailingAddress"
                            dense
                            outlined
                            v-on="on"
                            hide-details
                          ></v-text-field>
                        </div>
                      </td>
                    </tr>
                  </table>
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="title">More About You</v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-col xs="12" md="6">
                    <v-select
                      label="Gender"
                      :items="userGender_options"
                      item-text="text"
                      item-value="value"
                      v-model="userData.gender"
                    ></v-select>
                  </v-col>
                  <v-col xs="12" md="6">
                    <v-menu
                      v-model="bdPicker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="userData.birthday"
                          label="Your Birthday"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="userData.birthday" @input="bdPicker = false"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col xs="12" md="6">
                    <v-select
                      label="Ethnicity"
                      :items="ethnicity_options"
                      item-text="text"
                      item-value="value"
                      v-model="userData.ethnicity"
                    ></v-select>
                  </v-col>
                  <v-col xs="12" md="6">
                    <v-text-field
                      label="Occupation"
                      class="purple-input"
                      v-model="inputedRates.occupation"
                    />
                  </v-col>
                  <v-col xs="12" md="12">
                    What is your content niche/focus?
                    <!-- <v-textarea
                      class="purple-input"
                      label="Keywords be surface"
                      placeholder="(as many as you’d like!) Brands, interests (food, skincare, art, photography, fitness, etc.), race, nationality,
                      family condition (kids, parents, grandparents), occupation (office, entrepreneur, expat, home cook, parents),
                      life stage (pregnant, bto, first jobber), health condition (myopia, pimples, oily hair)"
                      v-model="userData.keywords"
                    /> -->
                    <v-chip-group multiple active-class="primary--text" v-model="userData.keywords" max="3" column>
                      <v-chip v-for="(item, index) in categories" :key="index" :value="item"      
                        class="ma-2"                               
                        filter                                                                                                                                                             
                      >
                        {{item}}
                      </v-chip>
                    </v-chip-group>
                  </v-col>
                  <v-col xs="12" md="12">
                    One liner about you (could emphasise on your niche to best represent your profile)
                    <v-textarea
                      filled
                      auto-grow
                      v-model="inputedRates.aboutYou"
                      hide-details="auto"
                    ></v-textarea>
                  </v-col>
                  <v-col  xs="12" md="12">
                    <v-radio-group class="mt-0" style="margin-bottom:10px" v-model="inputedRates.type" row hide-details>
                      <v-radio value="agency" label="Agency" class="justify-center"></v-radio>
                      <v-radio
                        value="direct"
                        label="Direct"
                        class="justify-center" >
                      </v-radio>
                    </v-radio-group>
                    <v-text-field
                      class="purple-input"
                      label="Agency Name"
                      v-if="inputedRates.type === 'agency'"
                      v-model="inputedRates.agencyName"
                      type="textbox"
                      outlined
                      hide-details
                    />
                  </v-col>
                  <!-- <v-col xs12>
                    <p
                      class="subtitle-1"
                    >Please let us know if you used any other social platforms:</p>
                    <v-tabs v-model="tab" show-arrows grow icons-and-text>
                      <v-tabs-slider></v-tabs-slider>
                      <v-tab
                        v-for="(platform, i) in socialPlatforms"
                        :href="'#tab-' + i"
                        :key="i"
                      >
                        {{platform.label}}
                        <v-avatar>
                          <img :src="platform.icon" :alt="platform.label" />
                        </v-avatar>
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                      <v-tab-item
                        v-for="(platform, i) in socialPlatforms"
                        :key="i"
                        :value="'tab-' + i"
                      >
                        <v-card flat>
                          <v-card-text>
                            <v-text-field
                              filled
                              :placeholder="platform.placeholder"
                              :label="platform.label"
                              v-model="userData.selectedSocialPlatforms[i].value"
                            ></v-text-field>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-col> -->
                </v-expansion-panel-content>
              </v-expansion-panel>
              <v-expansion-panel>
                <v-expansion-panel-header class="title">
                  <p>Your rates
                    <span class="caption">(in SGD per item)</span>
                  </p>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row id="profile-rate-card-form">
                    <v-col cols="12">
                      <v-col 
                      :class="section.class ? section.class : 'xs12 md6'"
                      :style="section.style || ''"
                      v-for="(section, index) in formConfig.sections" :key="index">
                        <div>
                          <v-col 
                          :class="field.class ? field.class : 'xs12 md6'"
                          :style="field.style || ''"
                          v-for="(field, index) in section.fields" :key="index">
                            <p :class="`h4 font-weight-bold mb-2 ${field.labelClass || ''}`" v-if="field.label !== ''  && !field.hideInternal">{{field.label}} <span class="red--text" v-if="field.required">*</span></p>
                            <!-- <v-text-field
                              class="purple-input"
                              v-model.number="inputedRates[field.name]"
                              type="number"
                              :prefix="field.prefix || ''"
                              v-if="field.type === 'number'"
                              :placeholder="field.placeholder ? field.placeholder : ''"
                            /> -->
                            <div class="d-flex flex-row pl-3" v-if="field.type === 'number'">
                              <v-select
                                class="currency-select"
                                style="margin-right: 5px;"
                                v-model.number="inputedRates[`${field.name}Currency`]"
                                :items="currenyOptions"
                                hide-details
                                dense
                                outlined
                              >
                              </v-select>
                              <v-text-field
                                class="purple-input"
                                v-model.number="inputedRates[field.name]"
                                type="number"
                                outlined
                                dense
                                v-if="field.type === 'number'"
                                :placeholder="field.placeholder ? field.placeholder : ''"
                              />
                            </div>
                            <v-text-field
                              class="purple-input"
                              v-model="inputedRates[field.name]"
                              type="textbox"
                              outlined
                              :style="field.fieldStyle || ''"
                              v-if="field.type === 'textbox' && !field.hideInternal"
                              :placeholder="field.placeholder ? field.placeholder : ''"
                            />
                            <v-textarea
                              filled
                              auto-grow
                              :hint="field.hint || ''"
                              :persistent-hint="field.hint ? true : false"
                              :placeholder="field.placeholder"
                              v-model="inputedRates[field.name]"
                              required
                              v-if="field.type === 'textarea'"
                              hide-details="auto"
                            ></v-textarea>
                            <div v-if="field.type === 'file'">
                              <custom-file-upload
                                :refresh="fileUploadRefresh"
                                :multiple="true"
                                @setMedias="updatePricingDecks"
                              />
                              <v-row v-if="inputedRates.pricingDecks.length > 0">
                                <v-col
                                  v-for="(img, index) in images"
                                  :key="index"
                                  class="d-flex child-flex"
                                  cols="12" sm="12" md="2" lg="1"
                                >
                                  <v-hover v-slot:default="{ hover }">
                                    <v-card
                                      flat
                                      tile
                                      class="d-flex"                              
                                      :elevation="hover ? 16 : 2"
                                    >
                                      <v-img                                  
                                        :src="img.url"
                                        :lazy-src="img.url"                                  
                                        class="grey lighten-2"
                                        aspect-ratio="1"
                                      ></v-img>
                                      <v-overlay absolute>
                                        <v-btn dark icon @click="deleteImage(index)">
                                          <v-icon dark color="red">cancel</v-icon>
                                        </v-btn>
                                      </v-overlay>
                                    </v-card>
                                  </v-hover>
                                </v-col>
                              </v-row>
                            </div>
                            <div v-if="field.type === 'multiple'">
                              <v-list v-for="(multipleOne, pIndex) in inputedRates[field.name]" :key="pIndex">
                                <v-list-item class="pa-0">
                                  <v-list-item-content 
                                    v-for="(multipleOption, oIndex) in field.options"
                                    :key="oIndex" 
                                    :style="multipleOption.style || ''">
                                    <!-- {{multipleOption.options}} -->
                                    <v-select
                                        class="pr-1"
                                        :items="multipleOption.options"
                                        item-value="value"
                                        item-text="label"
                                        hide-details
                                        v-model="inputedRates[field.name][pIndex][multipleOption.name]"
                                        :label="multipleOption.label"
                                        dense
                                        outlined
                                        v-if="multipleOption.type === 'select'"
                                        :style="multipleOption.style || ''"
                                      >
                                      </v-select>
                                      <v-text-field
                                        class="px-1"
                                        dense
                                        outlined
                                        hide-details
                                        :placeholder="multipleOption.placeholder"
                                        v-model="inputedRates[field.name][pIndex][multipleOption.name]"
                                        v-if="multipleOption.type === 'textbox'">
                                      </v-text-field>
                                      <!-- <v-text-field
                                        :class="multipleOption.class || ''"
                                        type="number"
                                        dense
                                        outlined
                                        hide-details
                                        :prefix="multipleOption.prefix || ''"
                                        :placeholder="multipleOption.name"
                                        v-model.number="inputedRates[field.name][pIndex][multipleOption.name]"
                                        v-if="multipleOption.type === 'number'">
                                      </v-text-field> -->
                                      <div class="d-flex flex-row" v-if="multipleOption.type === 'number'">
                                        <v-select
                                          class="currency-select"
                                          v-model.number="inputedRates[field.name][pIndex][`${multipleOption.name}Currency`]"
                                          :items="currenyOptions"
                                          hide-details
                                          dense
                                          outlined
                                        >
                                        </v-select>
                                        <v-text-field
                                          :class="multipleOption.class || ''"
                                          type="number"
                                          dense
                                          outlined
                                          hide-details
                                          :placeholder="multipleOption.name"
                                          v-model.number="inputedRates[field.name][pIndex][multipleOption.name]">
                                        </v-text-field>
                                      </div>
                                      <v-btn
                                        color="danger"
                                        @click="inputedRates[field.name].splice(pIndex, 1)"
                                        text
                                        x-small
                                        v-if="multipleOption.type === 'delete'">
                                        <v-icon color="red">mdi-delete-forever</v-icon>
                                      </v-btn>
                                  </v-list-item-content>
                                  <!-- <v-list-item-action>
                                    <v-text-field solo v-model.number="no_of_tiktok_posts"></v-text-field>
                                  </v-list-item-action> -->
                                </v-list-item>
                                
                                <v-list v-if="inputedRates[field.name][pIndex][field.child.parentName] === 'others'">
                                  <v-text-field
                                    class="px-2"
                                    dense
                                    outlined
                                    hide-details
                                    :placeholder="field.child.placeholder"
                                    v-model="inputedRates[field.name][pIndex][field.child.name]">
                                  </v-text-field>
                                </v-list>
                              </v-list>
                              <v-list class="float-right">
                                <v-list-item style="margin-top: -20px">
                                  <v-btn
                                  small
                                  color="secondary"
                                  @click="addPlatform(field.name)">
                                  <v-icon small>mdi-plus</v-icon> Add
                                  </v-btn>
                                </v-list-item>
                              </v-list>
                            </div>
                          </v-col>
                        </div>
                      </v-col>
                    </v-col>
                  </v-row>

                  <!-- <v-row>
                    <v-col xs="12" md="6">
                      <v-col xs="12" md="12">
                        <v-text-field
                          label="Instagram Handle"
                          class="purple-input"
                          v-model="inputedRates.instagramHandle"
                        />
                      </v-col>
                      <v-col xs="12" md="12">
                        <v-text-field
                          label="IG Story"
                          class="purple-input"
                          v-model.number="inputedRates.igStory"
                          type="number"
                        />
                      </v-col>
                      <v-col xs="12" md="12">
                        <v-text-field
                          label="IG Post"
                          class="purple-input"
                          v-model.number="inputedRates.igPost"
                          type="number"
                        />
                      </v-col>
                      <v-col xs="12" md="12">
                        <v-text-field
                          label="IG Carousel"
                          class="purple-input"
                          v-model.number="inputedRates.igCarousel"
                          type="number"
                        />
                      </v-col>
                      <v-col xs="12" md="12">
                        <v-text-field
                          label="IG Video"
                          class="purple-input"
                          v-model.number="inputedRates.igVideo"
                          type="number"
                        />
                      </v-col>
                      <v-col xs="12" md="12">
                        <v-text-field
                          label="IG Reel"
                          class="purple-input"
                          v-model.number="inputedRates.igReel"
                          type="number"
                        />
                      </v-col>
                      <v-col xs="12" md="12">
                        <v-text-field
                          label="IG TV"
                          class="purple-input"
                          v-model.number="inputedRates.igTv"
                          type="number"
                        />
                      </v-col>
                      <v-col xs="12" md="12">
                        <v-text-field
                          label="Loading Fee"
                          class="purple-input"
                          v-model.number="inputedRates.loadingFee"
                          type="number"
                        />
                      </v-col>
                      <v-col xs="12" md="12">
                        <v-text-field
                          label="Event Appearance"
                          class="purple-input"
                          v-model.number="inputedRates.eventAppearance"
                          type="number"
                          prefix="SGD $"
                        />
                      </v-col>
                      <v-col xs="12" md="12">
                        <v-textarea
                          filled
                          auto-grow
                          class="purple-input"
                          label="Remarks (Instagram)"
                          placeholder="If you have any thoughts on your rates, please let us know here."
                          v-model="inputedRates.igRemarks"
                        />
                      </v-col>
                    </v-col>
                    <v-col xs="12" md="6">
                      <v-col xs="12" md="12">
                        <v-text-field
                          label="TikTok Handle"
                          class="purple-input"
                          v-model="inputedRates.tiktokHandle"
                        />
                      </v-col>
                      <v-col xs="12" md="12">
                        <v-text-field
                          label="Tiktok"
                          class="purple-input"
                          v-model.number="inputedRates.tiktok"
                          type="number"
                        />
                      </v-col>
                      <v-col xs="12" md="12">
                        <v-textarea
                          filled
                          auto-grow
                          class="purple-input"
                          label="Remark"
                          placeholder="If you have any thoughts on your rates, please let us know here."
                          v-model="inputedRates.tiktokRemarks"
                        />
                      </v-col>
                      <v-col xs="12" md="12">
                        <v-text-field
                          label="Tiktok"
                          class="purple-input"
                          v-model.number="inputedRates.tiktok"
                          type="number"
                        />
                      </v-col>
                    </v-col>
                  </v-row>

                  <v-col xs="12" md="4">
                    <v-text-field
                      label="IG Static"
                      class="purple-input"
                      v-model.number="inputedRates.igStatic"
                      type="number"
                    />
                  </v-col>
                  <v-col xs="12" md="4">
                    <v-text-field
                      label="IG Carousel"
                      class="purple-input"
                      v-model.number="inputedRates.igCarousel"
                      type="number"
                    />
                  </v-col>
                  
                  <v-col xs="12" md="4">
                    <v-text-field
                      label="IG TV"
                      class="purple-input"
                      v-model.number="inputedRates.igTv"
                      type="number"
                    />
                  </v-col>
                  <v-col xs="12" md="4">
                    <v-text-field
                      label="Tiktok"
                      class="purple-input"
                      v-model.number="inputedRates.tiktok"
                      type="number"
                    />
                  </v-col>
                  <v-col xs="12" md="4">
                    <v-text-field
                      label="Blog"
                      class="purple-input"
                      v-model.number="inputedRates.blog"
                      type="number"
                    />
                  </v-col>
                  <v-col xs="12" md="4">
                    <v-text-field
                      label="Loading Fee"
                      class="purple-input"
                      v-model.number="inputedRates.loadingFee"
                      type="number"
                    />
                  </v-col> -->
                  <!-- <v-col xs="12" md="6">
                    <v-file-input
                      show-size
                      label="Your Pricing Deck (If any)"
                      ref="pricingDeck"
                      @change="pricingDeckUpload"
                    ></v-file-input>
                  </v-col> -->
                  <!-- <v-col xs="12" md="12"                    
                  >
                    Pricing Decks:
                     <v-btn                      
                      color="blue-grey"
                      class="ma-5 white--text"
                      @click="$refs.mediaUpload.click()"                 
                    >
                      Upload
                      <v-icon
                        right
                        dark
                      >
                        mdi-cloud-upload
                      </v-icon>
                    </v-btn>
                    <input
                        type="file"
                        name="media"
                        style="display: none"
                        ref="mediaUpload"
                        id="fileToUpload"
                        accept="image/*, .pdf, .ppt, .txt, .doc, .docx"
                        @change="prepareUpload"
                      />
                      <div>
                        <v-row v-if="images.length > 0">
                          <v-col
                            v-for="(img, index) in images"
                            :key="index"
                            class="d-flex child-flex"
                            cols="12" sm="12" md="2" lg="1"
                          >
                            <v-hover v-slot:default="{ hover }">
                              <v-card
                                flat
                                tile
                                class="d-flex"                              
                                :elevation="hover ? 16 : 2"
                              >
                                <v-img                                  
                                  :src="img.url"
                                  :lazy-src="img.url"                                  
                                  class="grey lighten-2"
                                  aspect-ratio="1"
                                ></v-img>
                                <v-overlay absolute>
                                  <v-btn dark icon @click="deleteImage(index)">
                                    <v-icon dark color="red">cancel</v-icon>
                                  </v-btn>
                                </v-overlay>
                              </v-card>
                            </v-hover>
                          </v-col>
                        </v-row>
                        <v-row v-if="decksFiles.length > 0" >
                          <v-col cols="12" sm="12" md="2" lg="1" v-for="(item, index) in decksFiles" :key="index" align="center">                   
                            <a v-if="item.type.indexOf('pdf') !== -1" :href="item.url" target="_blank">
                              <v-img
                                  width="67" height="85"
                                  src="./static/img/pdf.png"
                                  aspect-ratio="1"
                                ></v-img>
                            </a>                                                                                                               
                            <a v-if="item.type.indexOf('ppt') !== -1" :href="item.url" target="_blank">
                              <v-img
                                  width="67" height="85"
                                  src="./static/img/ppt.png"
                                ></v-img>
                            </a>
                            <a v-if="item.type.indexOf('doc') !== -1" :href="item.url" target="_blank">
                              <v-img
                                  width="67" height="85"
                                  src="./static/img/doc.png"
                                ></v-img>
                            </a>
                            <a v-if="item.type.indexOf('text') !== -1" :href="item.url" target="_blank">
                              <v-img
                                  width="67" height="85"
                                  src="./static/img/text.png"
                                ></v-img>
                            </a>                        
                            <v-btn dark icon @click="deleteFile(index)">
                              <v-icon dark color="red">cancel</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                  </v-col>
                  <v-col xs="12" md="12">
                    <v-textarea
                      filled
                      auto-grow
                      class="purple-input"
                      label="Remark"
                      placeholder="If you have any thoughts on your rates, please let us know here."
                      v-model="inputedRates.remark"
                    />
                  </v-col> -->
                </v-expansion-panel-content>
              </v-expansion-panel>
              <!-- Nyein Hide Account Deletion -->
              <!-- <v-expansion-panel>
                <v-expansion-panel-header class="title">Account Deletion</v-expansion-panel-header>
                <v-expansion-panel-content v-if="deleted">
                  <v-alert type="error">
                    <v-row align="center">
                      <v-col
                        class="grow"
                      >Deleted.</v-col>
                    </v-row>
                  </v-alert>
                </v-expansion-panel-content>
                <v-expansion-panel-content v-else>
                  <v-btn                      
                    color="warning"
                    class="mt-5 white--text"
                    @click="cancelDeleteReqAction()"
                    v-if="cancelRequest"                 
                  >
                    Cancel Delete Request
                    <v-icon
                      right
                      dark
                      color="white"
                    >
                      mdi-close-circle-outline
                    </v-icon>
                  </v-btn>
                  <v-btn                      
                    color="error"
                    class="mt-5 white--text"
                    @click="accountDeleteReqAction()"
                    v-else                 
                  >
                    Request Account Delete
                    <v-icon
                      right
                      dark
                      color="white"
                    >
                      mdi-delete
                    </v-icon>
                  </v-btn>
                </v-expansion-panel-content>
              </v-expansion-panel> -->
              <!-- End Account Deletion -->
            </v-expansion-panels>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="mx-0 font-weight-light"
              color="success"
              @click="editProfile"
            >Update Profile</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <!-- <v-col
        cols="12"
        xs="12"
        md="6"
      >
        <v-card>
          <v-card-title>Your Best Shots</v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                v-for="n in 6"
                :key="n"
                class="d-flex child-flex"
                cols="4"
              >
                <v-img
                  :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                  :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                  aspect-ratio="1"
                  class="grey lighten-2"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="openCloudinaryWidget()">Upload</v-btn>
          </v-card-actions>
        </v-card>
      </v-col> -->
    </v-row>
    <!-- User has a valid account -->
    <!-- User has an valid account -->
    <v-row v-if="!isValidAccount">
      <v-col cols="12" align="center" justify="center">
        <p>
          <b>Notice:</b>
          <i>
            Your account is not connected with your Instagram. Please click the button below to connect your Instagram account. 
            <br />If you have registered with Kobe before, please reauthorise and refresh due to the change of Facebook API requirement.
          </i>
        </p>
        <connect-instagram />
      </v-col>
    </v-row>
    <!-- <influencer-required-contact :dialog="showInfluencerRequiredField" :userData="userData" /> -->
    <v-dialog
      v-model="loading"      
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text style="padding-top:10px;">
          Updating...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <change-avatar-modal v-model="changeAvatarDialog" :value="changeAvatarDialog" @changeAvatar="uploadAvatar"></change-avatar-modal>
    <update-platform-modal v-model="updatePlatformDialog" :value="updatePlatformDialog" @connectIG="connectInstagram"></update-platform-modal>
    <billing-info-modal v-model="billingInfoDialog" :value="billingInfoDialog" :infData="userData" @updated="getUserProfile()"></billing-info-modal>
  </v-container>
</template>
<script>
import api from '@/api'
import moment from 'moment';
import { mapState } from 'vuex';
import userAPIs from './userAPIs';
import influencerAPIs from '../Influencer/influencerAPIs'
// import campaignAPIs from '../Campaign/campaignAPIs';
import config from '@/config';
import rateCardConfig from '../Influencer/RateCard/config';
import utils from '@/utils';
import apiURLs from '@/config/APIs';
import { getFbSdk } from '../../../plugins/fb-sdk';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import ConnectInstagram from '@/components/scoped/influencer/ConnectInstagram';
import ChangeAvatarModal from '@/components/ChangeAvatarModal'
import UpdatePlatformModal from '../Influencer/UpdatePlatformModal'
import BillingInfoModal from './BillingInfoModal';
import Jimp from 'jimp';
import CustomFileUpload from '../../scoped/custom/CustomFileUpload';
import influencerHelper from '../Influencer/influencerHelper'
import countries from '../../../../static/sources/countries';
// Influencer Profile Contact Required Modal
// import InfluencerRequiredContact from './InfluencerProfileRequiredModal.vue';

export default {
  name: 'Profile',
  components: { ConnectInstagram, ChangeAvatarModal, UpdatePlatformModal, BillingInfoModal, CustomFileUpload },
  mixins: [validationMixin],
  data() {
    return {
      valid: true,
      tab: null,
      loginByFacebook: false,
      bdPicker: false,
      openedPanels: [0, 1, 2],
      formConfig: rateCardConfig.formConfig,
      userData: {
        firstName: null,
        lastName: null,
        fullName: null,
        bankName: null,
        bankAccount: null,
        mailingAddress: null,
        postalCode: null,
        email: null,
        birthday: '',
        gender: 2,
        phone: null,
        selectedSocialPlatforms: config.socialMediaPlatforms,
        keywords: [],
        country: null,
        engagementRate: null,
        totalFollowers: null,
        igHandle: null,
        twitterHandle: null,
        linkedinHandle: null,
        reqLinkedinHandle: null,
        influencer: {},
        ethnicity: null,
        occupation: null
      },
      inputedRates: {
        igStory: 0,
        igStoryCurrency: 'SGD',
        igPost: 0,
        igPostCurrency: 'SGD',
        igCarousel: 0,
        igCarouselCurrency: 'SGD',
        igVideo: 0,
        igVideoCurrency: 'SGD',
        igReel: 0,
        igReelCurrency: 'SGD',
        igTv: 0,
        igTvCurrency: 'SGD',
        loadingFee: 0,
        loadingFeeCurrency: 'SGD',
        eventAppearance: 0,
        eventAppearanceCurrency: 'SGD',
        tiktok: 0,
        tiktokCurrency: 'SGD',
        platforms: [],
        pricingDecks: [],
        type: ''
      },
      // inputedRates: {
      //   igStatic: null,
      //   igCarousel: null,
      //   igStory: null,
      //   igTv: null,
      //   tiktok: null,
      //   blog: null,
      //   loadingFee: null,
      //   remark: '',
      //   pricingDecks: []
      // },
      userGender_options: [],
      ethnicity_options: [
        {
          value: 'chinese',
          text: 'Chinese'
        },
        {
          value: 'malay',
          text: 'Malay'
        },
        {
          value: 'Indian',
          text: 'indian'
        },
        {
          value: 'eurasian',
          text: 'Eurasian'
        },
        {
          value: 'others',
          text: 'Others'
        }
      ],
      socialPlatforms: [],
      countries: [],
      allBanks: [],
      bankNames: [],
      showUpdateInfo: false,
      showConnectBox: false,
      pwdWarning: false,
      pricingDecksMedia: [],
      images: [],
      decksFiles: [],
      loading: false,
      deleteObjectKeys: [],
      deleteSubmitting: false,
      cancelRequest: false,
      deleted: false,
      categories: influencerHelper.getCategories(),
      changeAvatarDialog: false,
      disableBankSelect: false,
      updatePlatformDialog: false,
      billingInfoDialog: false,
      currenyOptions: [
        'SGD',
        'USD',
        'IDR',
        'PHP',
        'THB',
        'MYR',
        'VND'
      ]
      // showInfluencerRequiredField: false
    };
  },
  watch: {
    userData: function(newUserData) {
      this.userData = newUserData;
    }
  },
  validations: {
    userData: {
      firstName: { required },
      // lastName: { required },
      email: { required }
      // phone: { required }
      // country: { required },
      // bankName: { required },
      // bankAccount: {
      //   required,
      // }
      // fullName: { required },
      // mailingAddress: { required }
    }
  },
  computed: {
    ...mapState(['user', 'activePlatform']),
    currentUserID: function() {
      return this.user.id;
    },
    influencerID: function() {
      return this.user.influencerID;
    },
    facebookId: function() {
      return this.user.facebookId;
    },
    activeUser() {
      return {
        displayName: this.user.firstName + ' ' + this.user.lastName,
        avatar: this.user.profilePicture ? this.user.profilePicture : '/static/img/avatar/user.png',
        email: this.user.email,
        createdAt: moment(this.user.createdAt).format('MMM D, YYYY'),
        role: config['userRolesDetails'][this.user.role]['display']
      };
    },
    firstNameErrors() {
      const errors = [];
      if (!this.$v.userData.firstName.$dirty) return errors;
      !this.$v.userData.firstName.required && errors.push('Firstname is required');
      return errors;
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.userData.lastName.$dirty) return errors;
      !this.$v.userData.lastName.required && errors.push('Lastname is required');
      return errors;
    },
    mailingAddressErrors() {
      const errors = [];
      if (!this.$v.userData.mailingAddress.$dirty) return errors;
      !this.$v.userData.mailingAddress.required && errors.push('Mailing Address is required');
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.userData.phone.$dirty) return errors;
      !this.$v.userData.phone.required && errors.push('Phone Number is required');
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.userData.email.$dirty) return errors;
      !this.$v.userData.email.required && errors.push('Email is required');
      return errors;
    },
    countryErrors() {
      const errors = [];
      if (!this.$v.userData.country.$dirty) return errors;
      !this.$v.userData.country.required && errors.push('Country is required');
      return errors;
    },
    bankNameErrors() {
      const errors = [];
      if (!this.$v.userData.bankName.$dirty) return errors;
      !this.$v.userData.bankName.required && errors.push('Bank Name is required');
      return errors;
    },
    bankAccountErrors() {
      const errors = [];
      if (!this.$v.userData.bankAccount.$dirty) return errors;
      !this.$v.userData.bankAccount.required && errors.push('Bank Account is required');
      return errors;
    },
    fullNameErrors() {
      const errors = [];
      if (!this.$v.userData.fullName.$dirty) return errors;
      !this.$v.userData.fullName.required && errors.push('Full Name is required');
      return errors;
    },
    isValidAccount() {
      const influencerID = this.influencerID;
      return influencerID !== '' && influencerID !== null && influencerID !== undefined;
    }
  },
  methods: {
    // pricingDeckUpload() {
    //   const file = this.$refs.pricingDeck.files[0];
    // },
    openCloudinaryWidget() {
      window.cloudinary.openUploadWidget({
        cloudName: 'kobeglobal',
        uploadPreset: 'jhlmriux',
        sources: [
          'local',
          'url'
        ],
        googleApiKey: '',
        showAdvancedOptions: false,
        cropping: false,
        multiple: true,
        defaultSource: 'local'
      }, (err, info) => {
        if (!err) {
          console.log('Upload Widget event - ', info);
        }
      });
    },
    userHasConnectedInstagram() {
      if (this.isValidAccount) {
        return true;
      }
      this.$swal({
        title: '<strong>Warning!</strong>',
        type: 'warning',
        html: 'Your instagram is not connected. Please connect with the necessary authorisation to proceed',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: 'primary',
        confirmButtonText: '<i class="fa fa-instagram"></i> Connect',
        cancelButtonText: 'Later'
      }).then(result => {
        if (result.value) {
          this.connectInstagram();
        }
      });
    },
    changePasswordModalIdDisplay: function() {
      return `#${this.changePasswordModalId}`;
    },
    async getFacebookStatus() {
      const fbSdk = await getFbSdk({ appId: config.FACEBOOK_APP_ID, version: 'v7.0' });
      fbSdk.getLoginStatus(response => {
        // console.log(response);
        this.loginByFacebook = response.status === 'connected';
      });
    },
    buildFormData(userProfile) {
      // let form = document.getElementById('campaignForm');
      let formData = new FormData();
      // Make sure the images appended at bottom
      // let images = formData.getAll('images')
      formData.append('editProfile', JSON.stringify(userProfile));
      let files = this.pricingDecksMedia;
      for (let val of files) {
        formData.append('deckFile', val);
      }
      return formData;
    },
    editProfile: function() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Please fill the required information correctly.'
        });
        return;
      }
      this.loading = true;
      if (typeof this.userData.bankName === 'object') {
        this.userData.swiftCode = this.userData.bankName.swift_code
        this.userData.bankName = this.userData.bankName.bank
      }
      let edittingUserProfile = Object.assign({ id: this.currentUserID }, this.userData);
      if (this.userData.birthday) {
        // Formating birthDate to only include date
        var birthDate = moment(this.userData.birthday).format('YYYY-MM-DD');
        edittingUserProfile.birthday = birthDate
      }
      edittingUserProfile.ethnicity = this.userData.ethnicity
      edittingUserProfile.occupation = this.userData.occupation
      delete edittingUserProfile.igHandle;
      delete edittingUserProfile.linkedinHandle;
      // Add Inputed Rates
      edittingUserProfile.inputedRates = this.inputedRates
      if (edittingUserProfile.email) {
        edittingUserProfile.email = edittingUserProfile.email.toLowerCase()
      }
      let formData = this.buildFormData(edittingUserProfile)
      // Edit User
      userAPIs
        .editProfile(formData)
        .then(response => {
          if (this.deleteObjectKeys.length > 0) {
            this.deleteObjectKeys.map(item => {
              api.request('delete', '/api/v1/posts/s3/delete', true, {image: item})
            })
          }
          // Success Message
          this.loading = false;
          this.$swal({
            title: 'Successfully updated!',
            text: 'Your profile has been updated successfully. Thank you for working with us!',
            type: 'success'
          });

          // Update local store
          const userState = this.$store.state.user;
          userState.firstName = this.userData.firstName;
          userState.lastName = this.userData.lastName;

          this.$store.commit('SET_USER', userState);
          if (window.localStorage) {
            window.localStorage.setItem('user', JSON.stringify(userState));
          }
          this.deleteObjectKeys = []
          this.getUserProfile()
        })
        .catch(error => {
          // Display popup message
          this.loading = false;
          this.$swal({
            title: 'Error!',
            text: 'Please kindly try again or contact us!',
            type: 'error'
          });

          // Request failed.
          console.log('error', error);
        });
    },
    async getUserProfile() {
      if (!this.influencerID || !this.currentUserID) {
        return;
      }
      userAPIs
        .getUser(this.currentUserID)
        .then(async (response) => {
          this.images = []
          this.decksFiles = []
          // handle for non-instagram registered influencers
          if ((!response.influencer.audience && !response.influencer.instagram) &&
          !response.influencer.tiktokaudience &&
          !response.influencer.youtubeaudience && !response.influencer.linkedin && !response.influencer.twitter && !response.influencer.reqIgHandle &&
          !response.influencer.reqTikTokHandle && !response.influencer.reqYoutubeHandle && !response.influencer.reqLinkedinHandle) {
            // this.showConnectBox = true
            this.updatePlatformDialog = true
          }
          let igEngRate, igTotalFollower
          if (response.influencer.instagram) {
            igEngRate =
            (
              Number(response.influencer.instagram.pricingData ? response.influencer.instagram.pricingData.engagementRate : 0) * 100
            ).toFixed(2) + '%';
            igTotalFollower = response.influencer.instagram.totalFollowers;
          } else if (response.influencer.tiktok) {
            igEngRate = (
              Number(response.influencer.tiktok.pricingData ? response.influencer.tiktok.pricingData.engagementRate : 0) * 100
            ).toFixed(2) + '%';
            igTotalFollower = response.influencer.tiktok.totalFollowers;
          } else if (response.influencer.linkedin) {
            igTotalFollower = response.influencer.linkedin.totalFollowers;
          }
          // for other social media platforms
          let inputtedOtherPlatforms = this.socialPlatforms.map(item => {
            var storePlatform = {
              label: item.label,
              value: item.value
            };
            return storePlatform;
          });
          if (response.influencer.otherSocialMedias) {
            response.influencer.otherSocialMedias.forEach(inputted => {
              this.socialPlatforms.forEach((platform, pIndex) => {
                if (platform.label === inputted.label) {
                  inputtedOtherPlatforms[pIndex].value = inputted.value;
                }
              });
            });
          }
          let keywords = []
          if (response.influencer.keywords && Array.isArray(response.influencer.keywords)) {
            // cleared out old keywords
            response.influencer.keywords.map(k => {
              if (this.categories.includes(k)) {
                keywords.push(k)
              }
            })
          }

          this.userData = {
            firstName: response.firstName,
            lastName: response.lastName,
            email: response.influencer.email,
            phone: response.influencer.phone,
            birthday: response.influencer.birthday ? moment(response.influencer.birthday).format('YYYY-MM-DD') : '',
            gender: response.influencer.gender,
            ethnicity: response.influencer.ethnicity,
            fullName: response.influencer.fullName,
            bankName: response.influencer.bankName,
            bankAccount: response.influencer.bankAccount,
            mailingAddress: response.influencer.mailingAddress,
            billingEmail: response.influencer.billingEmail || '',
            postalCode: response.influencer.postalCode,
            influencerId: response.influencer.id,
            totalFollowers: igTotalFollower || 'No Data',
            engagementRate: igEngRate || 'No Data',
            selectedSocialPlatforms: inputtedOtherPlatforms,
            country: response.influencer.country,
            keywords: keywords,
            occupation: response.influencer.occupation,
            reqIgHandle: response.influencer.reqIgHandle,
            reqTikTokHandle: response.influencer.reqTikTokHandle,
            reqYoutubeHandle: response.influencer.reqYoutubeHandle,
            reqLinkedinHandle: response.influencer.reqLinkedinHandle
          };
          if (response.influencer.instagram) {
            this.userData.igHandle = response.igHandle || response.influencer.instagram.instagramHandle
            this.inputedRates.igHandle = this.userData.igHandle
          }
          if (response.fbHandle || response.influencer.facebook || response.influencer.fbHandle) {
            this.userData.fbHandle = response.fbHandle || (response.influencer.facebook ? response.influencer.facebook.handle : '') || response.influencer.fbHandle || ''
          }
          if (response.influencer.tiktok) {
            this.userData.tiktokHandle = response.tiktokHandle || response.influencer.tiktok.tiktokHandle
            this.inputedRates.tiktokHandle = this.userData.tiktokHandle
          }
          if (response.influencer.youtube) {
            this.userData.youtubeHandle = response.youtubeHandle || response.influencer.youtube.youtubeHandle
          }
          if (response.influencer.twitter) {
            this.userData.twitterHandle = response.twitterHandle || response.influencer.twitter.twitterHandle
          }
          if (response.influencer.linkedin) {
            this.userData.linkedinHandle = response.linkedinHandle || response.influencer.linkedin.linkedinHandle
          }
          if (response.influencer.inputedRates) {
            // this.inputedRates = {
            //   igStatic: response.influencer.inputedRates['igStatic'],
            //   igCarousel: response.influencer.inputedRates['igCarousel'],
            //   igStory: response.influencer.inputedRates['igStory'],
            //   igTv: response.influencer.inputedRates['igTv'],
            //   tiktok: response.influencer.inputedRates['tiktok'],
            //   blog: response.influencer.inputedRates['blog'],
            //   loadingFee: response.influencer.inputedRates['loadingFee'],
            //   remark: response.influencer.inputedRates['remark'],
            //   pricingDecks: response.influencer.inputedRates['pricingDecks']
            // }
            if (!response.influencer.inputedRates.platforms) {
              response.influencer.inputedRates.platforms = []
            }
            this.inputedRates = Object.assign({}, response.influencer.inputedRates)

            // Add pricingDecks imagess
            if (this.inputedRates.pricingDecks.length > 0) {
              this.inputedRates.pricingDecks.map(item => {
                let mediaType = item.type.split('/')[0];
                if (mediaType === 'image') {
                  this.images.push(item)
                } else {
                  this.decksFiles.push(item)
                  // this.pricingDecksMedia.push(item)
                }
              })
            }
          }
          // check whether all the fields are updated
          this.isProfileUpdated();
          this.changeCountry()
          this.fileUploadRefresh = false
          setTimeout(() => {
            this.fileUploadRefresh = true
            this.checkOpenBillingDialog()
          }, 1000)
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    // Aung check Email
    // isEmailHave: function() {
    //   if (this.userData.email == null || this.userData.email === '') {
    //        this.showInfluencerRequiredField = true
    //   } else if (this.userData.phone == null || this.userData.phone === '') {
    //        this.showInfluencerRequiredField = true
    //   } else this.showInfluencerRequiredField = false
    // },
    // chether whether profile data are already filled or not
    isProfileUpdated: function() {
      if (
        this.userData.keywords == null ||
        this.userData.country == null ||
        this.userData.selectedSocialPlatforms == null ||
        this.userData.email == null ||
        this.userData.phone == null
      ) {
        this.showUpdateInfo = true;
      } else if (
        this.userData.keywords === '' ||
        this.userData.selectedSocialPlatforms === [] ||
        this.userData.email === '' ||
        this.userData.phone === '' ||
        this.userData.bankName === '' ||
        this.userData.bankAccount === '' ||
        this.userData.mailingAddress === ''
      ) {
        this.showUpdateInfo = true;
      } else {
        this.showUpdateInfo = false;
      }
    },
    connectInstagram() {
      window.location.href = utils.func.getInstagramAuthURL(
        { facebookId: this.facebookId, userId: this.currentUserID },
        apiURLs.INSTAGRAM_BASIC_DISPLAY_VERIFY
      );
    },
    prepareUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      uploadedFiles.forEach(element => {
        let mediaType = element.type.split('/')[0];
        let fileType = element.name.split('.')[1];

        if (mediaType !== 'image' && fileType !== 'pdf' && fileType !== 'doc' && fileType !== 'ppt' && fileType !== 'txt' && fileType !== 'docx') {
          this.$swal('File Type Not Supported, Please select a video or an image');
        } else if (mediaType === 'image') {
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = e => {
            let buffer = e.target.result;
            Jimp.read(buffer, (err, img) => {
              if (err) console.error(111, err);
              img
                .resize(500, Jimp.AUTO)
                .quality(100)
                .getBase64(Jimp.MIME_PNG, (err, buff) => {
                  if (err) console.error(222, err);
                  let file = utils.func.dataURLtoFile(buff, element.name);
                  this.pricingDecksMedia.push(file);
                  this.images.push({
                    url: buff,
                    src: buff,
                    name: element.name
                  });
                });
            });
          };
          // reset the input
          e.target.value = '';
        } else {
          this.decksFiles.push(element);
          this.pricingDecksMedia.push(element);
          const reader = new FileReader();
          reader.readAsArrayBuffer(element);
          e.target.value = '';
        }
      });
    },
    deleteImage(imgIndex) {
      let imgURl = this.images[imgIndex].url;
      // console.log('🚀 ~ file: Profile.vue ~ line 983 ~ deleteImage ~ this.images', this.images)
      let filename = this.images[imgIndex].url.substring(this.images[imgIndex].url.lastIndexOf('/') + 1)
      // console.log('🚀 ~ file: Profile.vue ~ line 977 ~ deleteImage ~ imgName', imgURl)
      this.deleteObjectKeys.push(filename)
      this.images.splice(imgIndex, 1)

      let pricingDecksMediaIndex = this.pricingDecksMedia.findIndex(item => item.url === imgURl)
      if (pricingDecksMediaIndex !== -1) this.pricingDecksMedia.splice(pricingDecksMediaIndex, 1)

      let inputRateIndex = this.inputedRates.pricingDecks.findIndex(item => item.url === imgURl)
      if (inputRateIndex !== -1) this.inputedRates.pricingDecks.splice(inputRateIndex, 1)
    },
    deleteFile(fileIndex) {
      let fileURL = ''
      if (this.decksFiles[fileIndex].url) {
        fileURL = this.decksFiles[fileIndex].url;
        let fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1)
        this.deleteObjectKeys.push(fileName)
      }
      this.decksFiles.splice(fileIndex, 1)
      // console.log('🚀 ~ file: Profile.vue ~ line 983 ~ deleteFile ~ this.deleteObjectKeys', this.deleteObjectKeys)
      let pricingDecksMediaIndex = this.pricingDecksMedia.findIndex(item => item.url === fileURL)
      if (pricingDecksMediaIndex !== -1) this.pricingDecksMedia.splice(pricingDecksMediaIndex, 1)

      let inputRateIndex = this.inputedRates.pricingDecks.findIndex(item => item.url === fileURL)
      if (inputRateIndex !== -1) this.inputedRates.pricingDecks.splice(inputRateIndex, 1)
    },
    accountDeleteReqAction() {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to send Account Delete Requeest?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        // Update submitting status
        if (result.value) {
          this.deleteSubmitting = true;
          let requestData = Object.assign({}, {
            influencerID: this.influencerID || '',
            instagramHandle: this.userData.igHandle || '',
            email: this.userData.email || '',
            firstName: this.userData.firstName || '',
            lastName: this.userData.lastName || ''
          });
          influencerAPIs
          .accountDeleteRequest({accountDeleteRequest: requestData})
          .then(response => {
            this.deleteSubmitting = false
            this.cancelRequest = true
          })
          .catch(error => {
            // Display popup message
            this.loading = false;
            this.$swal({
              title: 'Error!',
              text: 'Please kindly try again or contact us!',
              type: 'error'
            });

            // Request failed.
            console.log('error', error);
          });
        }
      })
    },
    cancelDeleteReqAction() {
      this.$swal({
        title: 'Double Check!',
        text: 'Are you sure you want to cancel Account Delete Requeest?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        // Update submitting status
        if (result.value) {
          this.deleteSubmitting = true;
          influencerAPIs
          .cancelDeleteRequest(this.influencerID)
          .then(response => {
            this.deleteSubmitting = false
            this.cancelRequest = false
          })
          .catch(error => {
            // Display popup message
            this.loading = false;
            this.$swal({
              title: 'Error!',
              text: 'Please kindly try again or contact us!',
              type: 'error'
            });
            // Request failed.
            console.log('error', error);
          });
        }
      })
    },
    async getInfluencerDeleteStatus() {
      influencerAPIs
        .accountDeleteStatus(this.influencerID)
        .then(response => {
          if (response && response.data.id) {
            if (response.data.status === config.accountDeleteStatus.DELETED) {
              this.deleted = true
            } else if (response.data.status === config.accountDeleteStatus.PENDING) {
              this.cancelRequest = true
            }
          }
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    async changeCountry() {
      try {
        this.bankNames = []
        let country = this.countries.find(c => c.name === this.userData.country)
        if (!country) {
          return;
        }
        this.disableBankSelect = true
        await this.getBanks(country.code)
        let matchBank = this.allBanks.find(bank => bank.country_code === country.code)
        if (matchBank && matchBank.list !== undefined) {
          this.bankNames = matchBank.list.filter(bank => bank.branch === null)
        }
        this.disableBankSelect = false
      } catch (err) {
        console.log(err)
        this.bankNames = []
        this.disableBankSelect = false
      }
    },
    changeProfilePicture() {
      this.changeAvatarDialog = true;
    },
    uploadAvatar(path) {
      this.$store.commit('SET_AVATAR', path)
      this.changeAvatarDialog = false;
      this.$swal({
        title: 'Success',
        text: 'Your avatar is updated.',
        type: 'success'
      })
    },
    async getBanks(code) {
      try {
        this.allBanks = await influencerAPIs.getBanks(code)
      } catch (error) {
        console.log('error', error);
      }
    },
    updatePricingDecks(medias) {
      this.pricingDecksMedia = Object.assign([], medias)
    },
    addPlatform(fieldName) {
      if (!this.inputedRates[fieldName]) {
        this.inputedRates[fieldName] = []
      }
      this.inputedRates[fieldName].push({
        platform: '',
        url: '',
        rate: '',
        rateCurrency: 'SGD'
      })
    },
    openUpdatePlatformDialog() {
      this.updatePlatformDialog = true
    },
    checkOpenBillingDialog() {
      if (!this.userData.fullName ||
      !this.userData.country ||
      !this.userData.bankName ||
      !this.userData.bankAccount ||
      !this.userData.billingEmail ||
      !this.userData.mailingAddress
      ) {
        this.billingInfoDialog = true
      }
    },
    // Remove spaces after input (to clear spaces if pasted somehow)
    removeSpaces() {
      this.$v.userData.email.$touch()
      this.userData.email = this.userData.email.replace(/\s/g, '');
    },
    // Prevent pasting spaces
    preventPasteSpaces(event) {
      let pastedText = (event.clipboardData || window.clipboardData).getData('text');
      if (/\s/.test(pastedText)) {
        event.preventDefault(); // Stops the paste action
      }
    }
  },
  async mounted() {
    this.$v.$touch();

    // Retrieve gender config
    this.userGender_options = config.userGenderDisplay;

    // Retrieve social platforms from config
    this.socialPlatforms = config.socialMediaPlatforms;

    // Retrieve countries manually
    this.countries = countries

    // Check warning password
    this.pwdWarning = this.$store.state.user.pwdWarning;

    // Check facebook login status
    this.getFacebookStatus();
    // Retrieve user profile
    this.getUserProfile();

    this.userHasConnectedInstagram();

    // get all campaign verticals
    // campaignAPIs
    //   .getAllCampaignVerticals(false)
    //   .then(response => {
    //     this.campaignVerticals = response.data;
    //     this.campaignVerticals = this.campaignVerticals.map(v => v.name)
    //   })
    //   .catch(error => {
    //     console.log('error', error);
    //   });

    // Get Influencer Status
    // await this.getInfluencerDeleteStatus();
  }
};
</script>
<style scoped>
  table {
    border-collapse: collapse;
    width: 100%;
    border:1px solid #dddddd;
  }
  table td .edit-field {
    font-size:13px;
  }
  th, td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
  }
  tr:hover {background-color:#f5f5f5;}
  @media only screen and (max-width: 768px) {
    .pp-section {
      min-width: 100%
    }
  }
  .currency-select {
    width: 86px;
    max-width: 60px;
    font-size: 12px;
  }
  .x-logo-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    border-radius: 3px;
    background: #000;
  }
  .x-logo-badge img,
  .x-logo-white {
    filter: invert(1);
  }
</style>
<style>
  #profile-rate-card-form .currency-select .v-input__slot {
    padding: 0;
    padding-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// Profile.vue?fb6f7940